import React from 'react';
import { InputNumber } from 'antd';

class CustomData extends React.Component {
  static getDerivedStateFromProps(nextProps) {
    // Should be a controlled component.
    if ('value' in nextProps) {
      return {
        ...(nextProps.value || {})
      };
    }
    return null;
  }

  constructor(props) {
    super(props);

    const value = props.value || {};
    this.state = {
      latitude: value.latitude || '',
      longitude: value.longitude || ''
    };
  }

  handleLatitudeValueChange = latitude => {
    if (!('value' in this.props)) {
      this.setState({ latitude });
    }
    this.triggerChange({ latitude });
  };

  handleLongitudeValueChange = longitude => {
    if (!('value' in this.props)) {
      this.setState({ longitude });
    }
    this.triggerChange({ longitude });
  };

  triggerChange = changedValue => {
    // Should provide an event to pass value to Form.
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(Object.assign({}, this.state, changedValue));
    }
  };

  render() {
    const { size } = this.props;
    const state = this.state;
    return (
      <span>
        <InputNumber
          // type="number"
          size={size}
          value={state.latitude}
          onChange={this.handleLatitudeValueChange}
          style={{ width: '47.5%', marginRight: '3%' }}
          placeholder="Latitude"
        />
        <InputNumber
          // type="number"
          size={size}
          value={state.longitude}
          style={{ width: '47.5%' }}
          onChange={this.handleLongitudeValueChange}
          placeholder="Longitude"
        />
      </span>
    );
  }
}
export default CustomData;
